import {useSearchParams} from "react-router-dom";
import React, {useEffect} from "react";
import Schulleitung from "./Schulleitung";
import Foerdervererin from "../foerderverein/Foerderverein"
import SubMenu from "../base/SubMenu";
import Sekretariat from "./Sekretariat";
import Bibliothek from "./Bibliothek";

export const Main = (props) => {

    const foerdervereinRef = React.createRef()
    const schulleitungRef = React.createRef()
    const sekretariatRef = React.createRef()
    const bibliothekRef = React.createRef()

    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        let scrollIntoViewValue = searchParams.get('scrollIntoView')
        if(scrollIntoViewValue === 'schulleitung'){
            schulleitungRef.current.scrollIntoView()
        } else if(scrollIntoViewValue === 'sekretariat'){
            sekretariatRef.current.scrollIntoView()
        } else if(scrollIntoViewValue === 'foerderverein'){
            foerdervereinRef.current.scrollIntoView()
        } else if(scrollIntoViewValue === 'bibliothek'){
            bibliothekRef.current.scrollIntoView()
                 }


    },[searchParams]);


    return(
        <React.Fragment>

            <React.Fragment>
                <SubMenu model={{
                    background: "rgb(38, 193, 101)",
                    items: [
                        { label: "SCHULLEITUNG", onClick: () => schulleitungRef.current.scrollIntoView()},
                        { label: "SEKRETARIAT" , onClick: () => sekretariatRef.current.scrollIntoView()},
                        { label: "FÖRDERVEREIN", onClick: () =>  foerdervereinRef.current.scrollIntoView()   },
                        { label: "BIBLIOTHEK", onClick: () => bibliothekRef.current.scrollIntoView() }



                    ]
                }}/>
                <div ref={schulleitungRef}><Schulleitung/></div>
                <div ref={sekretariatRef} style={{paddingTop: 'calc(var(--header-height))'}}><Sekretariat/></div>
                <div ref={foerdervereinRef} style={{paddingTop: 'calc(var(--header-height))'}}><Foerdervererin/></div>
                <div ref={bibliothekRef} style={{paddingTop: 'calc(var(--header-height))'}}><Bibliothek/></div>


            </React.Fragment>
        </React.Fragment>
    );
};

export default Main;